import { Injectable } from '@angular/core';
import 'parse';
const parse: typeof Parse = require('parse');

export class Subscription {
  name: string;
  subscription: Parse.LiveQuerySubscription;
}
@Injectable()
export class SubscriptionService {
  private subscriptions: {
    array: Subscription[],
    get(name: string): Subscription,
    del(name: string): void
  };
  constructor() {
    this.subscriptions = {
      array: [],
      get(name: string) {
        return this.array.find((s: Subscription) => s.name === name);
      },
      del(name: string): void {
        this.array = this.array.filter((s: Subscription) => s.name !== name);
      }
    };
  }

  /* Name: identifier to use when calling other methods on this subscription
  e.g. subscription.listen([name], ...) */
  sub(query: Parse.Query, name: string) {
    this.subscriptions.array.push({
      name: name,
      subscription: query.subscribe()
    });
  }

  listen(queryName: string, eventName: string, callback: Function) {
    this.subscriptions.get(queryName).subscription.on(eventName, callback);
  }

  ignore(queryName: string, eventName: string) {
    this.subscriptions.get(queryName).subscription.on(eventName, function () { });
  }

  unsub(queryName: string) {
    if (this.subscriptions.get(queryName).subscription.unsubscribe instanceof Function) {
      this.subscriptions.get(queryName).subscription.unsubscribe();
      this.subscriptions.del(queryName);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/service/subscription.service.ts